import { faChevronLeft, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex } from '@modusign/design-system';

import { useGNBFoldHandle } from '@app/containers/GlobalNavigationBar/GNBFoldHandleContext';

function GNBFoldHandler() {
  const { folded, toggleFolded } = useGNBFoldHandle();

  return (
    <Flex
      alignItems="center"
      as="button"
      height="40px"
      justifyContent="center"
      key="GNBFoldToggle"
      left={folded ? '64px' : '180px'}
      position="absolute"
      top="50%"
      width="40px"
      onClick={() => toggleFolded()}
    >
      <Flex
        alignItems="center"
        bg="white"
        border="1px solid"
        borderColor="boxBorderNeutralBase"
        borderRadius="50%"
        height="32px"
        justifyContent="center"
        width="32px"
      >
        <Box as={FontAwesomeIcon} icon={folded ? faChevronRight : faChevronLeft} />
      </Flex>
    </Flex>
  );
}

export default GNBFoldHandler;
